document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-notify-endpoint]').forEach(function (root) {
    const endpoint = root.dataset.notifyEndpoint;
    const trigger = root.querySelector('[data-notify-trigger]');
    const modal = root.querySelector('.product__restock-modal-overlay');
    const closeButton = root.querySelector('.product__restock-modal-close');
    const form = root.querySelector('[data-notify-form]');
    const successBox = form ? form.querySelector('.product__restock-form-success') : null;
    const errorBox = form ? form.querySelector('.product__restock-form-error') : null;
    const errorMessage = form ? form.querySelector('.product__restock-error-message') : null;
    const submitButton = form ? form.querySelector('button[type="submit"]') : null;

    if (!endpoint || !trigger || !modal || !form) {
      return;
    }

    function resetForm() {
      if (successBox) successBox.hidden = true;
      if (errorBox) errorBox.hidden = true;
      if (errorMessage) errorMessage.textContent = '';
      form.querySelectorAll('input, button').forEach(function (field) {
        if (field.type !== 'hidden') {
          field.disabled = false;
        }
      });
    }

    function openModal() {
      resetForm();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (window.location.hash === '#' + modal.id) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }

    function showSuccess() {
      if (successBox) successBox.hidden = false;
      if (errorBox) errorBox.hidden = true;
      form.querySelectorAll('input, button').forEach(function (field) {
        if (!field.closest('.product__restock-form-success')) {
          field.disabled = true;
        }
      });
    }

    function showError(message) {
      if (!errorBox || !errorMessage) return;
      errorMessage.textContent = message || 'Something went wrong. Please try again.';
      errorBox.hidden = false;
      if (successBox) successBox.hidden = true;
    }

    function setLoading(isLoading) {
      if (!submitButton) return;
      submitButton.disabled = isLoading;
      submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    trigger.addEventListener('click', function () {
      openModal();
    });

    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }

    const cancelButton = root.querySelector('.product__restock-cancel');
    if (cancelButton) {
      cancelButton.addEventListener('click', closeModal);
    }

    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    if (window.location.hash === '#' + modal.id) {
      openModal();
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      showError('');
      setLoading(true);

      const payload = {};
      new FormData(form).forEach(function (value, key) {
        payload[key] = value;
      });

      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) {
            return response.text().then(function (text) {
              throw new Error(text || response.statusText);
            });
          }
          return response.json().catch(function () {
            return { success: true };
          });
        })
        .then(function (data) {
          if (data && data.error) {
            throw new Error(data.error);
          }
          showSuccess();
        })
        .catch(function (error) {
          showError(error.message || 'Could not submit your request.');
        })
        .finally(function () {
          setLoading(false);
        });
    });
  });
});